
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/shared/ui/button';
import { Badge } from '@/components/shared/ui/badge';
import { useCartStore } from '@/features/user/stores/useCartStore';

export const CartButton = () => {
  const { setIsOpen, getTotalItems } = useCartStore();
  const itemCount = getTotalItems();

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative focus-visible:ring-0 focus-visible:ring-offset-0 focus:outline-none"
      onClick={() => setIsOpen(true)}
      aria-label="Abrir carrito"
    >
      <ShoppingCart className="h-4 w-4" strokeWidth={1.75} style={{ width: '22px', height: '22px', color: '#344c3d' }} />
      {itemCount > 0 && (
        <Badge className="absolute -top-0 -right-2 h-4 w-4 flex items-center justify-center text-xs p-0 bg-[#344c3d] ">
          {itemCount}
        </Badge>
      )}
    </Button>
  );
};
